<template>
  <div class="row justify-content-center m-0
  ">
    <div class="col-md-10 p-md-5">
      <swiper
      :spaceBetween="30"
      :centeredSlides="true"
      :autoplay="{
        delay: 3500,
        disableOnInteraction: false,
      }"
      :pagination="{
        clickable: true,
      }"
      :navigation="true"
      :modules="modules"
      :zoom="true"
      class="mySwiper"
    >
        <swiper-slide class="swiper-slide"
          ><img src="../assets/karussellSwiper/Bild1.jpg"  class="swiper-slide rundeEcken"/></swiper-slide
        ><swiper-slide
          ><img src="../assets/karussellSwiper/Bild2.jpg" class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img src="../assets/karussellSwiper/Bild3.jpg"  class="swiper-slide rundeEcken"/></swiper-slide
        ><swiper-slide
          ><img src="../assets/karussellSwiper/Bild4.jpg" class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img src="../assets/karussellSwiper/Bild5.jpg"  class="swiper-slide rundeEcken"/></swiper-slide
        ><swiper-slide
          ><img src="../assets/karussellSwiper/Bild6.jpg" class="swiper-slide"
        /></swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<!-- 
HILFE !!
https://swiperjs.com/demos#effect-fade 
-->

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/effect-flip";
import "swiper/css/pagination";
import "swiper/css/navigation";

import '../assets/mySwiper.css';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>
